import React from 'react'
import Experiment from '@mc/experiments-react'
import { TrendingTile } from 'pages/index/components/Marketing/components/TrendingTile'
import { TRENDING as TRENDING_SLUG } from 'libs/utils/categories'
import { trackTileClick } from 'components/CatalogExplorer/events'
import { CourseTile } from 'components/GlobalCarousel'

import { EXPERIMENT_KEY } from '../hooks/useTrackPen5038ExperimentViewed'
import { useTrendingTitle } from '../hooks/useTrendingTitle'

interface TrendingTileProps {
  tile: CourseTile
  openNewPage?: boolean
  // pen-5038_v1 experiment
  index?: number
  slug: string
}

const TrendingTileVariant = ({
  tile,
  openNewPage,
  index,
  slug,
}: TrendingTileProps) => {
  const trendingTitle = useTrendingTitle(slug)

  const handleClick = () => {
    trackTileClick({
      className: tile.title || tile.headline,
      category: slug === TRENDING_SLUG ? trendingTitle : slug,
    })(tile.link)
  }

  return (
    <TrendingTile
      tile={tile}
      onClick={handleClick}
      openNewPage={openNewPage}
      isJustLaunched={slug === TRENDING_SLUG && index === 0}
    />
  )
}

export const Pen5038TrendingTileWrapper = ({
  control,
  ...props
}: {
  control: React.ReactNode
} & TrendingTileProps) => (
  <Experiment
    name={EXPERIMENT_KEY}
    control={() => control}
    variant_1={TrendingTileVariant}
    {...props}
    track={false}
  />
)
